import styled from 'styled-components'

export const ReadonlyField = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 12px;
  padding-right: 12px;
  background: ${p => p.theme.colors.$alabaster};
  border-radius: 6px;
  user-select: text;
`

ReadonlyField.displayName = 'ReadonlyField'
